<template>
  <div id="iframe_box">
  </div>
</template>

<script>
  export default {
    name: 'pdfshower',
    data() {
      return {
        url:this.$route.query.url
      };
    },
    mounted(){
        var iframe='<iframe src="/pdfShow/web/viewer.html?file='+ this.url +'"'+' width="100%" height="800px"></iframe>';
        document.getElementById("iframe_box").innerHTML=iframe;
    },
    methods: {
      // 加载失败的callback
      onErr(err) {
        console.log('pdf加载失败,请重试');
        console.log('错误信息：', err);
      }
    }
  };
</script>
<style>
  #iframe_box{
    height:inherit!important;
  }
</style>
